import React, { useState, useEffect, useRef } from "react";
import { useWatchState, useModal } from "@/store";
import { BaseService } from "@/service";
import { Modal, Button, DatePicker } from "antd";
import { checkResult } from "@/common";
import { contrastOldObject } from "@/utils";
import moment from "moment";

const TABLE_NAME = "thtt_push_wechat";
const NAME = "pushTime";

const App = (props) => {

    const [autoPushTime, setAutoPushTime] = useState();

    const [[{ title = "设置时间", show, hide, width = 400, defaultTime, callback }]] = useWatchState(["modal." + NAME]);

    function onChange(value, dateString) {
        setAutoPushTime(new Date(dateString));
    }

    function submit() {
        if (callback) callback(autoPushTime);
        hide();
    }
    function cancel() {
        if (callback) callback(0);
        hide();
    }
    return (
        <Modal
            title={title}
            visible={show}
            width={width}
            maskClosable={false}
            destroyOnClose
            onCancel={hide}
            footer={false}
        >
            <div className="modal-pushTime">
                <p className="dark-second m-sm-b">请选择推送时间：</p>
                <DatePicker showTime={{ format: 'HH:mm' }} format="YYYY-MM-DD HH:mm" defaultValue={defaultTime && moment(defaultTime, "YYYY/MM/DD hh:mm")} placeholder="发布时间" onChange={onChange} />
                {Boolean(autoPushTime) && <p className="m-md-t dark-second">本文将于 {autoPushTime.format("yyyy 年 MM 月 dd 日 hh:mm:ss")} 发布</p>}
                <div className="flex row-end child-left-sm m-md-t">
                    <Button onClick={hide}>关闭</Button>
                    <Button type="danger" onClick={cancel}>取消定时</Button>
                    <Button type="primary" onClick={submit}>定时发布</Button>
                </div>
            </div>
        </Modal>
    );
}

export default App;
